import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, Collapse, } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { getRegularClasses, formatTime, formatFromTime, formaToTime } from '../../Utils/utils';
import moment from "moment/moment";
import { makeStyles } from '@material-ui/core/styles';
import './style.css'
import SetupModal from "./SetupModal";
import DataTableExtensions from "react-data-table-component-extensions";
import config from "../../config/config";
import axios from "axios";
import SuccessModal from "../Modals/SuccessModal";
import WarningModal from "../Modals/WarningModal";
import { toast } from "react-toastify";
import NotesshowModal from "../Modals/NotesshowModal";
import downImg from "./down-arrow.svg";
import UpImg from "./up-arrow.svg";
import { TimetoConvert } from "../../Utils/TimeUtils";
import CustomSearch from "../CustomSearch";
import LoadingSpinner from "../LoadingSpinner";

const ExpandedComponent = (props) => {
  const { data, setShowModal, setLangId, setSelectedRow, setCloseRow, setShowTime, setApprovedArr, approvedArr } = props;
  const [newArray, setNewArray] = useState([])
  const [notesShow, setNotesShow] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);

  const columns = [
    {
      name: 'Course No.',
      selector: row =>
        <div style={{ fontSize: '12px' }}>
          {row.courseNumber}
        </div>,
      sortable: false,
      width: '110px'
    },
    {
      name: 'Rank',
      cell: (row) =>
        <>
          <div className="row">
            <div className='cell-upper' style={{ fontSize: '12px' }}>{row.rank}</div>
          </div>
        </>,
      sortable: false,
      width: '80px',
    },
    {
      name: 'First Name',
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.firstName}
        </div>
      ),
      sortable: false,
      width: '110px',
    },
    {
      name: 'Last Name',
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.lastName}
        </div>
      ),
      sortable: false,
      width: '110px',
    },
    {
      name: 'Home Email',
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {row.homeEmail}
        </div>
      ),
      sortable: false,
      width: '250px'
    },
    {
      name: 'Phone number',
      selector: row => `${row.phoneNumber}`,
      sortable: false,
      width: '120px'
    },
    {
      name: "Timezone",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.timeZone}
        </div>
      ),
      width: "160px"
    },
    {
      name: 'Start Date',
      selector: row => moment(row.availableStartDateMs).format('MM/DD/YYYY'),
      sortable: false,
      width: '100px'
    },
    {
      name: 'End Date',
      selector: row => moment(row.availableEndDateMs).format('MM/DD/YYYY'),
      sortable: false,
      width: '100px'
    },
    {
      name: 'Availability in EST',
      width: '350px',
      cell: (row) => <div>
        <table>
          <thead className="cell-head">
            <th>Mon</th>
            <th>Tue</th>
            <th>Wed</th>
            <th>Thur</th>
            <th>Fri</th>
            <th>Sat</th>
            <th>Sun</th>
          </thead>
          <tbody>
            <tr className="cell-row">
              <td>
                <div className="display-time">
                  {row.updatedSchedule?.MON?.from ? <>
                    <div>{formatFromTime(row.updatedSchedule?.MON?.from)}</div>
                    <div>-</div>
                    <div>{formaToTime(row.updatedSchedule?.MON?.to)}</div>
                  </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.updatedSchedule?.TUE?.from == null ? '' :
                    <>
                      <div>{formatFromTime(row.updatedSchedule?.TUE?.from)}</div>
                      <div>-</div>
                      <div>{formaToTime(row.updatedSchedule?.TUE?.to)}</div>
                    </>
                  }
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.updatedSchedule?.WED?.from ? <>
                    <div>{formatFromTime(row.updatedSchedule?.WED?.from)}</div>
                    <div>-</div>
                    <div>{formaToTime(row.updatedSchedule?.WED?.to)}</div>
                  </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.updatedSchedule?.THUR?.from ? <>
                    <div>{formatFromTime(row.updatedSchedule?.THUR?.from)}</div>
                    <div>-</div>
                    <div>{formaToTime(row.updatedSchedule?.THUR?.to)}</div>
                  </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.updatedSchedule?.FRI?.from ? <>
                    <div>{formatFromTime(row.updatedSchedule?.FRI?.from)}</div>
                    <div>-</div>
                    <div>{formaToTime(row.updatedSchedule?.FRI?.to)}</div>
                  </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.updatedSchedule?.SAT?.from ? <>
                    <div>{formatFromTime(row.updatedSchedule?.SAT?.from)}</div>
                    <div>-</div>
                    <div>{formaToTime(row.updatedSchedule?.SAT?.to)}</div>
                  </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.updatedSchedule?.SUN?.from ? <>
                    <div>{formatFromTime(row.updatedSchedule?.SUN?.from)}</div>
                    <div>-</div>
                    <div>{formaToTime(row.updatedSchedule?.SUN?.to)}</div>
                  </> : ''}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>,
      sortable: false,
    },

    // {
    //   name: 'Availability in EST',
    //   width: '350px',
    //   cell: (row) => <div>
    //     <table>
    //       <thead className="cell-head">
    //         <th>Mon</th>
    //         <th>Tue</th>
    //         <th>Wed</th>
    //         <th>Thur</th>
    //         <th>Fri</th>
    //         <th>Sat</th>
    //         <th>Sun</th>
    //       </thead>
    //       <tbody>
    //         <tr className="cell-row">
    //           <td>
    //             <div className="display-time">
    //               {row.updatedSchedule?.MON?.from ? <> {TimetoConvert(row.updatedSchedule?.MON?.from, row.updatedSchedule?.MON?.to, row.updatedSchedule?.MON?.timezone)} </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //             {row.updatedSchedule?.TUE?.from ? <> {TimetoConvert(row.updatedSchedule?.TUE?.from, row.updatedSchedule?.TUE?.to, row.updatedSchedule?.TUE?.timezone)} </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //             {row.updatedSchedule?.WED?.from ? <> {TimetoConvert(row.updatedSchedule?.WED?.from, row.updatedSchedule?.WED?.to, row.updatedSchedule?.WED?.timezone)} </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //             {row.updatedSchedule?.THUR?.from ? <> {TimetoConvert(row.updatedSchedule?.THUR?.from, row.updatedSchedule?.THUR?.to, row.updatedSchedule?.THUR?.timezone)} </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //             {row.updatedSchedule?.FRI?.from ? <> {TimetoConvert(row.updatedSchedule?.FRI?.from, row.updatedSchedule?.FRI?.to, row.updatedSchedule?.FRI?.timezone)} </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //             {row.updatedSchedule?.SAT?.from ? <> {TimetoConvert(row.updatedSchedule?.SAT?.from, row.updatedSchedule?.SAT?.to, row.updatedSchedule?.SAT?.timezone)} </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //             {row.updatedSchedule?.SUN?.from ? <> {TimetoConvert(row.updatedSchedule?.SUN?.from, row.updatedSchedule?.SUN?.to, row.updatedSchedule?.SUN?.timezone)} </> : ''}
    //             </div>
    //           </td>
    //         </tr>
    //       </tbody>
    //     </table>
    //   </div>,
    //   sortable: false,
    // },
    {
      name: 'Can be added to',
      selector: row => ``,
      sortable: false,
    },
    {
      name: "Notes",
      width: '120px',
      selector: (row) =>
        <div style={{
          margin: '5px',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.notes}
        </div>
    },
    // {
    //   name: "Notes",
    //   cell: (row) => {
    //     const handleOpenModal = (notes) => {
    //       setSelectedNote(notes); 
    //       setNotesShow(true); 
    //     };
    //     return (
    //       <div className='cell-link'>
    //         <i 
    //           className="fas fa-eye"
    //           title="Notes"
    //           onClick={() => handleOpenModal(row.notes)} 
    //         ></i>
    //       </div>
    //     );
    //   }
    // }
  ];

  useEffect(() => {
    const copiedData = [...data.students];
    setNewArray(copiedData);
  }, [data.students]);

  return (
    <>
      <div>
        <DataTable
          columns={columns}
          data={newArray}
        />
        <Row className="w-100  mb-3 ">
          <Col md={4}>
            <button
              className="btn btn-primary btn-xs mx-3"
              disabled={newArray.every((data) => data.space_a_ind == "T")}
              onClick={(e) => {
                if (newArray.length == 1 && newArray[0].space_a_ind == "T") {
                  setSelectedRow(data)
                  setShowTime(true)
                  setLangId(newArray[0]?.lang.id)
                  setShowModal(true)
                } else {
                  setShowTime(false)
                  setSelectedRow(data)
                  setLangId(newArray[0]?.lang.id)
                  setShowModal(true)
                }
              }}
            >
              Setup Schedule
            </button>
          </Col>
          {(data.isReadyToApprove == true && data.isApproved == false) &&
            <Col md={4}>
              <button
                className="btn btn-success btn-xs "
                onClick={(e) => {
                  // data.isApproved = true
                  setSelectedRow(data.isApproved = true)
                  setCloseRow(data)
                  var arr = [...approvedArr]
                  arr.push(data)
                  setApprovedArr(arr)
                  // setLangId(row.lang.id)
                  // setShowModal(true)
                }}
              >
                Approve
              </button>
            </Col>
          }
        </Row>
      </div >
      {notesShow && (
        <NotesshowModal
          notesShow={notesShow}
          setNotesShow={setNotesShow}
          selectedNote={selectedNote}
          setSelectedNote={setSelectedNote}
          notes={selectedNote}
        />
      )}
    </>
  )
};

const FlexGroupedClasses = (props) => {
  const [regualarClasses, setRegualarClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [lang_id, setLangId] = useState('');
  const [isSetup, setIsSetup] = useState(false);
  const [closeRow, setCloseRow] = useState('');
  const [approvedArr, setApprovedArr] = useState([]);
  const [showTime, setShowTime] = useState(false);
  const [isSuccessShow, setIsSuccessShow] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [filterText, setFilterText] = useState('');
  const handleFilterChange = (e) => { setFilterText(e.target.value); };

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const getAllRegularClasses = async () => {
    setIsLoading(true)
    setRegualarClasses(props.selectArray)
    setIsLoading(false)
  }
  useEffect(() => {
    getAllRegularClasses()
  }, [])

  const columns = [
    {
      name: 'Course Number',
      selector: row => `+ ${row.mainClassNumber}`,
      sortable: false,
    },
  ];
  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL",

  };
  const useStyles = makeStyles(theme => ({
    root: {
      width: '50%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));
  const customStyles = {
    rows: {
      style: {
        minHeight: '72px',
        backgroundColor: '#cccccc'
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        backgroundColor: '#8A8A8A',
      },
    },
    cells: {
      style: {
        fontSize: '17px',
        fontWeight: 600,
        color: '#555555',
      },
    },
  };
  const expandComp = (row, i) => {
    if (closeRow?.mainClassNumber == row?.mainClassNumber) {
      return false
    } else {
      return true
    }

  }
  const showSelectRow = (row) => {
    if (closeRow?.mainClassNumber == row?.mainClassNumber) {
      return true
    } else {
      return false
    }

  }
  const isRowSelectable = (row) => {
    // console.log(row)
    // Your condition to disable row selection
    return row.isApproved == false ? true : false; // Replace with your condition
  };
  const conditionalRowStyles = [
    {
      when: row => row.space_a_ind === 'T',
      style: {
        backgroundColor: '#fb6f46',
        color: 'black',
        '&:hover': {
          backgroundColor: '#FDB7A2 !important',
          cursor: 'pointer',
        },
      },
    }
  ];
  const onSubmit = async () => {

    setIsLoading(true)
    var temp = []
    approvedArr.map((a) => {
      var obj = {}
      const hasSelected = a.newMatchedTimings.some(t => t.isSelected);

      const timingsToUse = a.newMatchedTimings.filter(t => t.isSelected)

      // const timingsToUse = hasSelected
      //   ? a.newMatchedTimings.filter(t => t.isSelected)
      //   : a.newMatchedTimings;

      timingsToUse.map((q) => {
        var timee = (q.classTime).split('-')
        var toTime = timee[1].slice(0, -3)
        obj[q?.classDay] = {
          "from": timee[0],
          "to": toTime
        }

      })
      temp.push({

        "mainClassNumber": a.mainClassNumber,
        "matchedTimings": a.matchedTimings,
        "selectedSchedule": obj,
        "matchedIn": a.matchedIn,
        "language": a.language,
        "availableStartDate": a.availableStartDate,
        "students": a.students,
        "generatedHash": a.generatedHash,
        "instructorAccepted": a.instructorAccepted,
        "instructorEmail": a.instructorEmail,
        "instructorId": a.instructorId,
        "instructorName": a.instructorName,
        "isApproved": a.isApproved,
        "isFlex": a.isFlex,
        "isReady": a.isReady,
        "isReadyToApprove": a.isReadyToApprove,
        "isTimesSetup": a.isTimesSetup

      })
    })
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/group-raw-data', {
      data: temp
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        setIsLoading(false)
        setIsSuccessShow(true)
        // let aprArr = []
        // approvedArr.map((apr) => {
        //   aprArr.push(apr.mainClassNumber)
        // })
        // const filteredArray = regualarClasses.filter(item => !aprArr.includes(item.mainClassNumber));
        // setRegualarClasses(filteredArray)
      })
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      });
  }
  const onProceed = () => {
    setIsShow(false)
    onSubmit()
  }
  const onClose = () => {
    setIsSuccessShow(false)
    let aprArr = []
    approvedArr.map((apr) => {
      aprArr.push(apr.mainClassNumber)
    })
    const filteredArray = regualarClasses.filter(item => !aprArr.includes(item.mainClassNumber));
    setRegualarClasses(filteredArray)
  }
  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div>
        <div className="row mb-4">
          <div className="col-md-12">
            {regualarClasses.length > 0 ?
              <div className="card m-overflow-h todo-card-list" style={{ border: 'none' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#8A8A8A' }}>
                  <div className='heading-texts-2' style={{ color: '#ffffff', marginLeft: '20px' }}>
                    Flex Group Classes
                  </div>
                  <div>
                    <img
                      src={isOpen == true ? UpImg : downImg}
                      style={{ width: '26px', height: '26px', cursor: 'pointer', marginRight: '20px' }}
                      onClick={toggleCollapse}
                    />
                  </div>
                </div>
                <div className="col-lg-3 mt-2">
                  <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
                </div>
                <div className="card-body m-p-0 p-0">
                  <Collapse in={isOpen}>
                    <div>
                      <DataTableExtensions
                        columns={columns}
                        data={
                          regualarClasses.filter((item) => {
                            const filter = filterText.toLowerCase().trim();

                            const itemMatch = Object.values(item).some((value) =>
                              String(value).toLowerCase().includes(filter)
                            );

                            const studentMatch = item.students?.some((student) =>
                              Object.entries(student).some(([key, value]) => {
                                const strValue = String(value).toLowerCase();

                                if (key === "courseNumber") {
                                  const match = String(value).match(/-(\d{2}).*(\w{2})$/);
                                  const extracted = match ? match[1] + match[2] : "";
                                  if (extracted.toLowerCase() === filter) {
                                    return true;
                                  }
                                }

                                return strValue.includes(filter);
                              })
                            );

                            // const langMatch = !langVal || item.language.code === langVal.value;

                            return (itemMatch || studentMatch);
                          })
                        }
                        print={false}
                        export={false}
                        filter={false}
                      >
                        <DataTable
                          expandableRows
                          expandableRowExpanded={(row) => expandComp(row)}
                          expandableRowsComponent={ExpandedComponent}
                          pagination
                          expandOnRowClicked
                          conditionalRowStyles={conditionalRowStyles}
                          selectableRows
                          selectableRowSelected={(row) => approvedArr.some(item => item?.mainClassNumber == row.mainClassNumber)}
                          expandableRowsComponentProps={{
                            "setShowModal": setShowModal,
                            "setLangId": setLangId,
                            "setSelectedRow": setSelectedRow,
                            "setCloseRow": setCloseRow,
                            "setShowTime": setShowTime,
                            "filterText": filterText,
                            "setApprovedArr": setApprovedArr,
                            "approvedArr": approvedArr
                          }}
                          onSelectedRowsChange={({ selectedRows }) => {
                            setApprovedArr(selectedRows)
                          }}
                          paginationPerPage={10}
                          paginationRowsPerPageOptions={[10, 25, 50, 100]}
                          selectableRowDisabled={isRowSelectable}
                          noTableHead={true}
                          expandableRowsHideExpander={true}
                          customStyles={customStyles}
                          className="custom-table-border"
                        />
                      </DataTableExtensions>
                      <Row className="w-100 display-center mt-5">
                        <div className="btn-box-2">
                          <div className="main-btn" onClick={() => {
                            if (approvedArr.length > 0) {
                              setIsShow(true)
                            } else {
                              toast.error('Please select classes')
                            }
                          }} >
                            Approve flex classes
                          </div>
                        </div>
                      </Row>
                    </div>
                  </Collapse>
                </div>
              </div>
              :
              <div className="no-record">
                There are no records to display.
              </div>
            }
          </div>
        </div>
      </div>
      {showModal == true ?
        <SetupModal
          showModal={showModal}
          setShowModal={setShowModal}
          lang_id={lang_id}
          setIsSetup={setIsSetup}
          setCloseRow={setCloseRow}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          closeRow={closeRow}
          showTime={showTime}
          isIstructorValue={true}

        // regualarClasses={regualarClasses}
        />
        : null}
      {isSuccessShow == true ?
        <SuccessModal
          isSuccessShow={isSuccessShow}
          setIsSuccessShow={setIsSuccessShow}
          onClose={onClose}
        />
        : null}
      {isShow == true ?
        <WarningModal
          isShow={isShow}
          setIsShow={setIsShow}
          onProceed={onProceed}
        />
        : null}
    </>
  )
}
export default FlexGroupedClasses